<div class="loader" [ngStyle]="{width:width}"></div>
